// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__hUcwf","infoBtn":"quickbooks_infoBtn__1Bo1L","formBox":"quickbooks_formBox__2DUSm","formFooter":"quickbooks_formFooter__2jbk5"};